import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { LivesState, LivesApiResponse, LiveCardProps } from '../types';

const initialState: LivesState = {
  lives: [],
  productClassUuid: '',
  liveCardDetails: null,
  openLiveConfirmation: false,
};

const livesSlice = createSlice({
  name: 'lives',
  initialState,
  reducers: {
    setLivesAction(state, action: PayloadAction<LivesApiResponse>) {
      state.lives = action.payload.lives;
      state.productClassUuid = action.payload.productClassUuid;
    },

    clearLivesAction(state) {
      state.lives = [];
      state.productClassUuid = '';
    },

    setLiveDetailsAction(state, action: PayloadAction<LiveCardProps | null>) {
      state.liveCardDetails = action.payload;
    },

    setOpenLiveConfirmationAction(state, action: PayloadAction<boolean>) {
      state.openLiveConfirmation = action.payload;
    },
  },
});

export const { setLivesAction, clearLivesAction, setLiveDetailsAction, setOpenLiveConfirmationAction } = livesSlice.actions;

export const getLives = (state: RootState): LivesState => state.lives;

export default livesSlice.reducer;
